import React, { useEffect, useState } from "react";
import "./FAQ.scss";
import Accordion from "react-bootstrap/Accordion";
import { FaPlus } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import useShimmer from "../../../../hooks/useShimmer";
import { fetchFaqListApi } from "../../../../services/faqs";
import useDebounce from "../../../../hooks/useDebounce";
import InfiniteScroll from "react-infinite-scroll-component";
import { toastMessage } from "../../../../utils/toastMessage";

const FAQ = () => {
  const [faqList, setFaqList] = useState([])
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState('')
  const debouncedValue = useDebounce(search, 300);

  //-----------------test-scrolling--------------------------------
  const faqListing = async (page = 1, isRefresh = false) => {
    try {
      const { data } = await fetchFaqListApi({
        pagination: "true",
        search: debouncedValue,
        limit: 10,
        page,
      });
      const { data: exploreList, success, message, meta } = data;
      if (success) {
        if (isRefresh) {
          setFaqList(exploreList || []);
        } else {
          setFaqList((prev) => [...prev, ...(exploreList || [])]);
        }
        setHasMore(exploreList.length === 10);
      } else {
        toastMessage(message, 'error', 'faqElse')
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    faqListing(1, true);
  }, [debouncedValue]);

  const fetchMoreData = () => {
    setPage((prevPage) => {
      const nextPage = prevPage + 1;
      faqListing(nextPage);
      return nextPage;
    });
  };
  return (
    <>
      <div className="faq_section">
        <div className="container_faq">
        <h3 className="profile_title">Frequently asked question</h3>
        </div>

        <div className="faq_accordion">
          <Accordion >
            <InfiniteScroll
              dataLength={faqList.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader='loading...  '
            >
              {faqList && faqList.length > 0 ? faqList.map((data, ind) => (
                <Accordion.Item eventKey={ind}>
                  <Accordion.Header>
                    <p>{data?.title || "N/A"}</p>
                    <span className="show_add">
                      <FaPlus />
                    </span>
                    <span className="show_hide">
                      <FaMinus />
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>{data?.description || "N/A"} </p>
                  </Accordion.Body>
                </Accordion.Item>
              )) : null}
            </InfiniteScroll>
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default FAQ;
